import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
   selector: 'app-choice',
   templateUrl: './choice.component.html',
   styleUrls: ['./choice.component.css']
})
export class ChoiceComponent {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() choices: any;
   @Input() classes: any;
   @Input() hideHeader: boolean = false;

   constructor() {
   }

}
